import React, { memo } from 'react';
import { textPositionOptions } from 'core/constant/SELECT_OPTIONS';
import { InputText, DropdownField } from 'components/common/input';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';

const BannerItem = ({ provided, banner, index, handleInputChange, handleFileChange, handleEditClick, handleDeleteClick, errors }) => (
    <div className="row card-drag m-0 form-group" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
        <div className="col-md-2">
            <InputText
                label="Título"
                value={banner.title}
                onChange={(e) => handleInputChange(index, 'title', e.target.value)}
                error={errors?.title}
            />
        </div>
        <div className="col-4 col-md-4 col-lg-4 col-xxl-5">
            <InputText
                label="Descripción"
                value={banner.description}
                onChange={(e) => handleInputChange(index, 'description', e.target.value)}
                error={errors?.description}
            />
        </div>
        <div className="col-md-2">
            <DropdownField
                label="Posición del Texto"
                value={banner.textPosition}
                placeholder="Centro"
                options={textPositionOptions}
                onChange={(e) => handleInputChange(index, 'textPosition', e.value)}
                error={errors?.textPosition}
            />
        </div>
        <div className="col">
            <div className="d-flex flex-column justify-content-center align-items-start h-100">

                <ImageWithBaseApi
                    className="banner-image"
                    src={banner.backgroundImage}
                    alt="Imagen del Banner"
                    style={{
                        top: 0,
                        left: 0,
                        height: '50px',
                        objectFit: 'cover',
                    }}
                />
            </div>
        </div>
        <div className="col-1">
            <div className="d-flex align-items-center mb-3 mt-4 w-100 justify-content-end">
                <div className="btn-icon-modal me-3" onClick={() => handleDeleteClick(banner)}>
                    <i className="fas fa-trash-alt cursor-pointer text-danger"></i>
                </div>
                <div className="btn btn-primary-300 p-1 px-2" style={{ fontSize: '15px' }} onClick={() => handleEditClick({ ...banner, index })}>
                    Editar
                </div>
            </div>
        </div>
    </div>
);

export default memo(BannerItem);
